import logo from '../../assets/vidhura.png';

/*
 * Brand lockup. Uses the existing `vidhura.png` as the glyph and renders
 * the wordmark alongside so the nav works on both light and dark themes.
 */
export default function Logo({ height = 56, withWordmark = false, className = '' }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={logo}
        alt="Vidhura Technologies"
        height={height}
        style={{ height }}
        className="w-auto object-contain select-none dark:invert dark:hue-rotate-180"
        draggable={false}
      />
      {withWordmark && (
        <span className="hidden sm:inline font-display text-lg md:text-xl font-semibold tracking-tight text-ink-900 dark:text-ink-50">
          Vidhura
          <span className="text-ink-400 dark:text-ink-300 font-medium"> Technologies</span>
        </span>
      )}
    </span>
  );
}
